// const GID = "G-546CJRPF4X";
const GTM_ID = "GTM-THGS5KZF";
const dataLayer = (window.dataLayer = window.dataLayer || []);

export const onClientEntry = () => {
  dataLayer.push({
    event: "timing_complete",
    name: "bootstrap",
    value: Math.round(performance.now()),
  });
};

export const onInitialClientRender = () => {
  // const gtagScript = document.createElement("script");
  // gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GID}`;
  // document.head.appendChild(gtagScript);

  dataLayer.push({
    event: "gtm.start",
    'gtm.start': new Date().getTime()
  });

  const gtmScript = document.createElement("script");
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(gtmScript);

  dataLayer.push({
    event: "timing_complete",
    name: "hydration",
    value: Math.round(performance.now()),
  });
};

export function onRouteUpdate(_, pluginOptions) {
  // wrap inside a timeout to ensure the title has properly been changed
  setTimeout(() => {
    const eventName = `route-change`

    dataLayer.push({ event: eventName })
  }, 50)
}


export const registerServiceWorker = () => true;
